import React from 'react';
import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '5547984931793';
const DEFAULT_MESSAGE = 'Olá! Vim pelo site da ELETROVEX e gostaria de mais informações.';

const FloatingWhatsApp = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 right-6 z-40 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition-all hover:scale-110 flex items-center gap-2 group"
    >
      <MessageCircle size={28} />
      <span className="hidden group-hover:inline-block font-bold pr-2 whitespace-nowrap">
        Fale conosco
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
